<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Búsqueda Reclamos</span>
                    </h4>
                    <div class="m-b-30 card-container">
                        <div class="card-body">
                            <div class="general-label">
                                <!--<div class="form-group">
                                    <label>Búsqueda por NIT</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchNit">
                                </div>-->
                                <div class="form-group">
                                    <label>Ingrese información para buscar</label>
                                    <div class="mt-3">
                                        Buscar por: <br>
                                        <select v-model="typesearch" class="form-control">
                                            <option value="placa" selected>Placa</option>
                                            <option value="reclamo">Reclamo</option>
                                        </select>
                                    </div>
                                    <div class="mt-3">
                                        <div v-if="typesearch === 'placa'">
                                            <span class="mt-1">Ingrese No. Placa</span>
                                            <input ref="searchOne" type="text" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                            <div class="mt-2">
                                                <span>Seleccione Moneda</span>
                                                <select v-model="searchExtraUno" class="form-control">
                                                    <option value="Q" selected>Quetzales</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div v-if="typesearch === 'reclamo'">
                                            <div class="mt-1">
                                                <span class="mt-1">Ingrese No.Reclamo</span>
                                                <input ref="searchOne" type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                            </div>
                                            <div class="mt-2">
                                                <span class="mt-2">Seleccione Ramo</span>
                                                <select v-model="searchExtraDos" class="form-control">
                                                    <option value="91" selected>91 - Vehiculos</option>
                                                </select>
                                                <!--<input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchExtraDos">-->
                                            </div>
                                            <div class="mt-2">
                                                <span>Seleccione Moneda</span>
                                                <select v-model="searchExtraUno" class="form-control">
                                                    <option value="Q" selected>Quetzales</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--<h5 class="text-primary">Otros</h5>
                                <div class="form-group">
                                    <label>No.Póliza</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí">
                                </div>
                                <div class="form-group">
                                    <label>No.Requerimiento</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí">
                                </div>-->
                                <div class="text-right d-flex gap-2 flex-wrap justify-content-end">
                                    <button @click="searchValue = ''; deducibles = {}; $refs.searchOne.focus()" type="button" class="btn btn-warning mr-2 btn__limpiar">Limpiar</button>
                                    <button @click="preSearch" type="button" class="btn btn-primary btn__buscar">Buscar</button>
                                </div>
                            </div>
                            <div class="searchResultContainer">
                                <div class="searchResult">
                                    <div v-if="Object.keys(deducibles).length > 0">
                                        <div v-if="(typesearch === 'placa')">
                                            <div v-for="item in deducibles" class="resultItem">
                                                <div class="font-weight-bold">
                                                    {{ item.prMarcav }} {{ item.prLineav }} {{ item.prAoveh }}
                                                    <div>
                                                        Nombre Asegurado: {{ (item.prColase) ? item.prColase : 'N/D' }}
                                                    </div>
                                                </div>
                                                <div class="mt-2 searchResultBadges">
                                                    <div class="miniInfo">
                                                        <span>Reclamo 1: </span>
                                                        <span v-if="item.prRecla1">
                                                            Info: {{ item.prRecla1 }}
                                                            <a :href="'/reclamos/reclamo/' + item.prRecla1 + '/' + this.searchExtraUno+ '/91'" class="text-primary text-underline cursor-pointer ml-2">Ver detalles</a>
                                                        </span>
                                                        <span v-else class="text-secondary">N/D</span>
                                                    </div>
                                                    <div class="miniInfo">
                                                        <span>Reclamo 2: </span>
                                                        <span v-if="item.prRecla2">
                                                            Info: {{ item.prRecla2 }}
                                                            <a :href="'/reclamos/reclamo/' + item.prRecla2 + '/' + this.searchExtraUno+ '/91'" class="text-primary text-underline cursor-pointer ml-2">Ver detalles</a>
                                                        </span>
                                                        <span v-else class="text-secondary">N/D</span>
                                                    </div>
                                                    <div class="miniInfo">
                                                        <span>Reclamo 3: </span>
                                                        <span v-if="item.prRecla3">
                                                            Info: {{ item.prRecla3 }}
                                                            <a :href="'/reclamos/reclamo/' + item.prRecla3 + '/' + this.searchExtraUno+ '/91'" class="text-primary text-underline cursor-pointer ml-2">Ver detalles</a>
                                                        </span>
                                                        <span v-else class="text-secondary">N/D</span>
                                                    </div>
                                                </div>
                                                <!--<div class="text-center mt-2">
                                                    <button @click="$router.push('/deducibles/' + poliza.llave_poliza + '?poliza=' + poliza.poliza)" class="btn btn-primary m-auto">
                                                        <i class="fa fa-eye"></i> Ver deducibles
                                                    </button>
                                                </div>-->
                                            </div>
                                        </div>
                                        <div v-if="(typesearch === 'reclamo')">
                                            <div v-for="item in deducibles" class="resultItem">
                                                <div class="font-weight-bold mb-2">
                                                    {{ item.prNomcli }}
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Correo electrónico:</span> {{ (item.prMailcl) ? item.prMailcl : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">NIT:</span> {{ (item.prNitcli) ? item.prNitcli : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Teléfono:</span> {{ (item.prTelfcl) ? item.prTelfcl : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Póliza:</span> {{ (item.prPoliza) ? item.prPoliza : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Placa:</span> {{ (item.prNumpla) ? item.prNumpla : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Marca:</span> {{ (item.prMarcav) ? item.prMarcav : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Línea:</span> {{ (item.prLineav) ? item.prLineav : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Año:</span> {{ (item.prAnoveh) ? item.prAnoveh : 'N/D' }}
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Fecha:</span> {{ (item.prFecsin) ? item.prFecsin : 'N/D' }}
                                                    </div>
                                                </div>
                                                <div class="mt-2 mb-2 searchResultBadges">
                                                    <div class="row m-0">
                                                        <div class="col-6">
                                                            <div class="font-weight-bold">
                                                                Monto:
                                                            </div>
                                                            <div class="miniInfo">
                                                                <div v-if="item.prVltdep">
                                                                    <span>Depreciación:</span><br> {{ searchExtraUno }} {{
                                                                        Numbro((item.prVltdep) ? item.prVltdep : 0).format({
                                                                            thousandSeparated: true,
                                                                            mantissa: 2
                                                                        })
                                                                    }}
                                                                </div>
                                                                <span v-else class="text-secondary">N/D</span>
                                                            </div>
                                                            <div class="miniInfo">
                                                                <div v-if="item.prVltded">
                                                                    <span class="text-secondary">Monto:  {{ searchExtraUno }} {{
                                                                            Numbro((item.prVltded) ? item.prVltded : 0).format({
                                                                                thousandSeparated: true,
                                                                                mantissa: 2
                                                                            })
                                                                        }} </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-6">
                                                            <div class="font-weight-bold">
                                                                Monto (F):
                                                            </div>
                                                            <div class="miniInfo">
                                                                <div v-if="item.prVltdep">
                                                                    <span>Depreciación:</span><br> {{ searchExtraUno }} {{
                                                                        Numbro((item.prVltdep) ? item.prVltdep : 0).format({
                                                                            thousandSeparated: true,
                                                                            mantissa: 2
                                                                        })
                                                                    }}
                                                                </div>
                                                                <span v-else class="text-secondary">N/D</span>
                                                            </div>
                                                            <div class="miniInfo">
                                                                <div v-if="item.prVltded">
                                                                    <span class="text-secondary">Monto:  {{ searchExtraUno }} {{
                                                                            Numbro((item.prVltdei) ? item.prVltdei : 0).format({
                                                                                thousandSeparated: true,
                                                                                mantissa: 2
                                                                            })
                                                                        }} </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--<div class="miniInfo">
                                                        <span v-if="item.prVltdei">
                                                            <span>Monto con factura:</span> {{searchExtraUno}} {{ Numbro((item.prVltdei) ? item.prVltdei : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                                                        </span>
                                                        <span v-else class="text-secondary">N/D</span>
                                                    </div>-->
                                                </div>
                                                <!--<div class="text-center mt-2">
                                                    <button @click="$router.push('/deducibles/' + poliza.llave_poliza + '?poliza=' + poliza.poliza)" class="btn btn-primary m-auto">
                                                        <i class="fa fa-eye"></i> Ver deducibles
                                                    </button>
                                                </div>-->
                                                <inicio-pago typepago="deducible" :pago-pendiente="(typeof item.pPnd !== 'undefined') ? item.pPnd : 0" :onlyfact="(typeof item.pLF !== 'undefined') ? item.pLF : 'none'" :pago-log="(typeof item.pL !== 'undefined') ? item.pL : false" :item="item" bloqueoaplicar="true"></inicio-pago>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="searched && Object.keys(deducibles).length === 0" class="text-center text-muted">
                                        No se encontraron pólizas
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";


export default {
    props: {},
    components: {
        Pago,
        //TimelineChart,
        Layout,
        //Toster,
        InicioPago
    },
    data() {
        return {
            Valid: {},
            searchExtraUno: "Q",
            searchExtraDos: "",
            searchValue: "",
            typesearch: "placa",
            searched: false,
            deducibles: {},

            // para pago directo
            pagar: 0,
            tipoPago: '',
            nit: '',
            nombre: '',
            direccion: '',
            polizaNo: '',

            // para pago
            pagandoref: 0,
            pagosToApply: {}
        };
    },
    mounted() {
        if (!Tools.tieneParamsBusquedaRuta(this.$route.params)) {
            return;
        }
        this.searchValue = this.$route.params.search;
        this.typesearch = this.$route.params.type;
        this.searchExtraUno = this.$route.params.extra;
        this.searchExtraDos = this.$route.params.extrados;
        this.search();
    },
    methods: {
        Numbro,
        dayjs,
        search() {

            const self = this;
            this.deducibles = {};

            let url = '';

            if (self.typesearch === 'placa') {
                self.searchExtraUno = self.searchExtraUno.toString().toUpperCase();
                url = 'reclamos/placa?s=' + self.searchValue + '&m=' + self.searchExtraUno;
            }
            else if (self.typesearch === 'reclamo') {
                url = 'reclamos/reclamo?s=' + self.searchValue + '&m=' + self.searchExtraUno + '&r=' + self.searchExtraDos;
            }

            store.dispatch('coreShowLoading');

            API.send('GET', url, null,
                function (response) {
                    store.dispatch('coreHideLoading');

                    if (response.status) {
                        self.deducibles = (typeof response.data === "object") ? response.data : {};

                        self.searched = true;
                    }
                    else {
                        self.searched = true;
                        alert(response.msg);
                    }

                },
                function () {
                    self.searched = true;
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                })
        },
        preSearch() {

            if (parseInt(this.searchValue) === 0 || Tools.isEmptyString(this.searchValue)) {
                return false;
            }

            if (this.typesearch === 'placa') {
                if (this.searchValue === '' || this.searchExtraUno === '') {
                    alert('Ingrese todos los campos');
                    return false;
                }
                this.$router.push({path: '/reclamos/placa/' + this.searchValue + '/' + this.searchExtraUno});
            }
            else if (this.typesearch === 'reclamo') {
                if (this.searchValue === '' || this.searchExtraUno === '' || this.searchExtraDos === '') {
                    alert('Ingrese todos los campos');
                    return false;
                }
                this.$router.push({path: '/reclamos/reclamo/' + this.searchValue + '/' + this.searchExtraUno + '/' + this.searchExtraDos});
            }
            //this.$forceUpdate();
            this.search();
        },
        showPago(requerimiento, tipoPago) {
            this.nit = requerimiento.nit;
            this.nombre = requerimiento.asegurado;
            this.direccion = requerimiento.direccion;
            this.pagar = requerimiento.requerimiento;
            this.poliza = requerimiento.poliza;
            this.tipoPago = tipoPago;
        },
        /*activarPagandoRef(data) {
            this.pagandoref = data;
        },*/
        cancelarPago() {
            this.pagar = 0;
        },
    },
};
</script>
